import { useState } from "react";
import { useIntl } from "react-intl";
import { localizedMessageOf } from "@/lib/localized-error";
import { userErrorMessage } from "@/lib/user-error";

export function useOrganizationalRecordAction() {
  const intl = useIntl();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function run(action: () => Promise<unknown>) {
    if (busy) return;
    setBusy(true);
    setError(null);
    try { await action(); } catch (failure) { setError(localizedMessageOf(failure) ?? userErrorMessage(intl, failure)); }
    finally { setBusy(false); }
  }
  return { busy, error, run };
}
